import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

const SampleCollectionPage = () => {
    const navigate = useNavigate();

    const [formData, setFormData] = useState({
        testName: '',
        name: '',
        phone: '',
        city: 'Skardu',
        address: '',
        date: '',
        time: ''
    });

    const availableTests = [
        "CBC (Complete Blood Count)",
        "Lipid Profile",
        "Liver Function Test (LFT)",
        "Renal Function Test (RFT)",
        "Thyroid Profile (T3, T4, TSH)",
        "Blood Sugar Fasting",
        "HbA1c",
        "Vitamin D Total",
        "Full Body Checkup",
        "Dengue NS1 Antigen",
        "Uric Acid",
        "Calcium",
        "Covid-19 PCR"
    ];
    const locations = [
        "Skardu", "Ghanche", "Shigar", "Kharmang", "Roundu", "Gilgit", "Hunza"
    ];

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (!formData.city) {
            alert("Please select a city/location.");
            return;
        }
        axios.post(process.env.REACT_APP_API_BASE_URL + "/sample-collections/add", formData)
            .then(res => {
                alert('Booking Confirmed! Our team will contact you shortly.');
                navigate('/');
            })
            .catch(err => alert('Error booking request.'));
    };

    return (
        <div style={{ backgroundColor: '#f8f9fa', paddingBottom: '50px' }}>

            {/* --- 1. HERO BANNER --- */}
            <div className=" text-white text-center py-3 mb-5" style={{ background: 'rgb(28,28,28)' }}>
                <h1 className="fw-bold display-4" style={{ fontSize: '2.5rem' }}>Free Home Sample Collection</h1>
                <p className="lead" style={{ fontSize: '1.1rem' }}>Safe, Hygienic & Convenient Lab Tests at your Doorstep</p>
            </div>

            <div className="container">


                <div className="row text-center mb-5 justify-content-center">
                    <div className="col-12 mb-4"><h3 className="fw-bold">How it Works</h3></div>

                    <div className="col-md-3 mb-3">
                        <div className="p-4 bg-white rounded shadow-sm h-100">
                            <div className="display-4 text-primary mb-3"><i className="bi bi-calendar-check"></i></div>
                            <h5>1. Book Test</h5>
                            <p className="text-muted small">Select your test and schedule a visit.</p>
                        </div>
                    </div>
                    <div className="col-md-3 mb-3">
                        <div className="p-4 bg-white rounded shadow-sm h-100">
                            <div className="display-4 text-warning mb-3"><i className="bi bi-geo-alt"></i></div>
                            <h5>2. Collection</h5>
                            <p className="text-muted small">Phlebotomist visits your home for sample.</p>
                        </div>
                    </div>
                    <div className="col-md-3 mb-3">
                        <div className="p-4 bg-white rounded shadow-sm h-100">
                            <div className="display-4 text-success mb-3"><i className="bi bi-file-earmark-medical"></i></div>
                            <h5>3. Get Report</h5>
                            <p className="text-muted small">Receive reports online or via WhatsApp.</p>
                        </div>
                    </div>
                </div>

                <div className="row g-4">


                    <div className="col-lg-8">
                        <div className="card border-0 shadow-sm rounded-3 p-4">
                            <h4 className="fw-bold mb-4 text-primary">Patient Details</h4>
                            <form onSubmit={handleSubmit}>


                                <div className="mb-3">
                                    <label className="form-label fw-bold">Select Test / Package</label>
                                    <input type="text" list="testOptions" className="form-control bg-light" placeholder="Type or select a test..." name="testName" value={formData.testName} onChange={handleChange} required />
                                    <datalist id="testOptions">
                                        {availableTests.map((test, index) => <option key={index} value={test} />)}
                                    </datalist>
                                </div>


                                <div className="row g-3 mb-3">
                                    <div className="col-md-6">
                                        <label className="form-label fw-bold">Patient Name</label>
                                        <input
                                            type="text"
                                            className="form-control bg-light"
                                            name="name"
                                            value={formData.name}
                                            onChange={handleChange}
                                            required
                                        />
                                    </div>
                                    <div className="col-md-6">
                                        <label className="form-label fw-bold">Phone Number</label>
                                        <input
                                            type="tel"
                                            className="form-control bg-light"
                                            name="phone"
                                            value={formData.phone}
                                            onChange={handleChange}
                                            required
                                        />
                                    </div>

                                </div>

                                <div className="mb-3">
                                    <label className="form-label fw-bold">Select Location (City)</label>
                                    <select className="form-select bg-light" name="city" value={formData.city} onChange={handleChange} required>
                                        <option value="">-- Choose Location --</option>
                                        {locations.map((loc, index) => (
                                            <option key={index} value={loc}>{loc}</option>
                                        ))}
                                    </select>
                                </div>

                                <div className="mb-3">
                                    <label className="form-label fw-bold">Full Address</label>
                                    <textarea
                                        className="form-control bg-light"
                                        rows="2"
                                        placeholder="House No, Street, Colony, City"
                                        name="address"
                                        value={formData.address}
                                        onChange={handleChange}
                                        required
                                    ></textarea>
                                </div>


                                <div className="row g-3 mb-4">
                                    <div className="col-md-6">
                                        <label className="form-label fw-bold">Preferred Date</label>
                                        <input
                                            type="date"
                                            className="form-control bg-light"
                                            name="date"
                                            value={formData.date}
                                            onChange={handleChange}
                                            required
                                        />
                                    </div>
                                    <div className="col-md-6">
                                        <label className="form-label fw-bold">Time Slot</label>
                                        <select
                                            className="form-select bg-light"
                                            name="time"
                                            value={formData.time}
                                            onChange={handleChange}
                                            required
                                        >
                                            <option value="">Select Time</option>
                                            <option value="08:00 AM - 10:00 AM">08:00 AM - 10:00 AM</option>
                                            <option value="10:00 AM - 12:00 PM">10:00 AM - 12:00 PM</option>
                                            <option value="12:00 PM - 02:00 PM">12:00 PM - 02:00 PM</option>
                                            <option value="02:00 PM - 04:00 PM">02:00 PM - 04:00 PM</option>
                                            <option value="04:00 PM - 06:00 PM">04:00 PM - 06:00 PM</option>
                                        </select>
                                    </div>
                                </div>

                                <button type="submit" className="btn btn-warning w-100 py-3 fw-bold fs-5 shadow-sm">
                                    Confirm Booking
                                </button>

                            </form>
                        </div>
                    </div>


                    <div className="col-lg-4">

                        <div className="card border-0 shadow-sm rounded-3 mb-4">
                            <div className="card-header bg-white border-bottom py-3">
                                <h5 className="mb-0 fw-bold">Order Summary</h5>
                            </div>
                            <div className="card-body">
                                <div className="d-flex justify-content-between mb-2">
                                    <span>Home Collection Charges</span>
                                    <span className="text-success fw-bold">FREE</span>
                                </div>
                                <div className="d-flex justify-content-between mb-3">
                                    <span>Report Consultation</span>
                                    <span className="text-success fw-bold">FREE</span>
                                </div>
                                <hr />
                                <div className="alert alert-info small mb-0">
                                    <i className="bi bi-info-circle me-1"></i>
                                    Test charges will be calculated based on the selected tests and collected at home.
                                </div>
                            </div>
                        </div>

                        <div className="card border-0 shadow-sm rounded-3 bg-white p-4">
                            <h5 className="fw-bold mb-3">Why Choose Us?</h5>
                            <ul className="list-unstyled mb-0 d-grid gap-3">
                                <li className="d-flex align-items-center">
                                    <i className="bi bi-check-circle-fill text-primary me-3 fs-5"></i>
                                    <span>Certified Phlebotomists</span>
                                </li>
                                <li className="d-flex align-items-center">
                                    <i className="bi bi-check-circle-fill text-primary me-3 fs-5"></i>
                                    <span>Safe & Hygienic Process</span>
                                </li>
                                <li className="d-flex align-items-center">
                                    <i className="bi bi-check-circle-fill text-primary me-3 fs-5"></i>
                                    <span>On-time Sample Collection</span>
                                </li>
                                <li className="d-flex align-items-center">
                                    <i className="bi bi-check-circle-fill text-primary me-3 fs-5"></i>
                                    <span>Accurate Reports</span>
                                </li>
                            </ul>
                        </div>

                    </div>

                </div>
            </div>
        </div>
    );
};

export default SampleCollectionPage;